import NoResultsIcon from "../../../assets/NoResultsIcon";

type Props = {
    reportName: string;
    searchTerm?: string;
    onClear: () => void;
    actionLabel?: string;
};

export default function StoreReportNoResultsMessage({
    reportName,
    searchTerm,
    onClear,
    actionLabel = searchTerm ? "Clear search" : "Clear filters",
}: Props) {
    return (
        <div className="store-report-placeholder">
            <span className="store-report-placeholder__icon">
                <NoResultsIcon />
            </span>
            <h2 className="store-report-placeholder__title">No {reportName.toLowerCase()} found</h2>
            <p className="store-report-placeholder__description">
                {searchTerm
                    ? <>No results match &quot;{searchTerm}&quot;. Try a different search term, or clear your search and filters.</>
                    : <>No results match your filters. Try adjusting or clearing them.</>}
            </p>
            <button
                type="button"
                className="store-report-placeholder__action store-report-placeholder__action--secondary"
                onClick={onClear}
            >
                {actionLabel}
            </button>
        </div>
    );
}
